import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteLocation } from '../../../../actions';

class LocationDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteLocation, locationId } = this.props;
    dispatchDeleteLocation({ locationId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

LocationDeleteButton.propTypes = {
  locationId: PropTypes.number.isRequired,
  dispatchDeleteLocation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteLocation: deleteLocation,
};

export default connect(null, mapDispatchToProps)(LocationDeleteButton);
